import { useId } from 'react';

import { HStack, Heading, Icon, Text, VStack } from '@betterment/samba-react';
import { ErrorMessage } from 'formik';

import { ContributionRateEditor } from './ContributionRateEditor';
import { ContributionRateFormValues } from './types';
import { createFormikFieldName } from './utils';

export const LegalAccountsContributionsEditor = ({
  compensationType,
  hasRothAccount,
  isSubmitting,
}: {
  compensationType: keyof ContributionRateFormValues;
  hasRothAccount: boolean;
  isSubmitting: boolean;
}) => {
  const headingId = useId();
  const headerText = compensationType === 'base' ? 'Base pay' : 'Bonus';
  return (
    <VStack role="group" aria-describedby={headingId} css={{ gap: 'space.300' }}>
      <Heading id={headingId} variant="title200">
        {headerText}
      </Heading>
      <ContributionRateEditor
        formikFieldName={createFormikFieldName(compensationType, 'traditional')}
        label="Traditional 401(k)"
        isSubmitting={isSubmitting}
      />
      {hasRothAccount && (
        <ContributionRateEditor
          formikFieldName={createFormikFieldName(compensationType, 'roth')}
          label="Roth 401(k)"
          isSubmitting={isSubmitting}
        />
      )}
      <ErrorMessage name={createFormikFieldName(compensationType)}>
        {message =>
          typeof message === 'string' && (
            <HStack css={{ gap: 'space.50', justifyContent: 'flex-end' }}>
              <Icon name="CancelFilled" size="small" color="icon.critical" />
              <Text color="text.critical">{message}</Text>
            </HStack>
          )
        }
      </ErrorMessage>
    </VStack>
  );
};
